import script from "./knowledgeBase.vue?vue&type=script&setup=true&lang=js"
export * from "./knowledgeBase.vue?vue&type=script&setup=true&lang=js"

import "./knowledgeBase.vue?vue&type=style&index=0&id=3c43f566&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c43f566"]])

export default __exports__